
(function () {
  if (window.__rpStackUpsellBound) return;
  window.__rpStackUpsellBound = true;

  document.addEventListener('click', async function (event) {
    var btn = event.target && event.target.closest && event.target.closest('.rp-stack-upsell__btn');
    if (!btn) return;
    event.preventDefault();
    var id = btn.getAttribute('data-rp-stack-variant');
    if (!id || btn.disabled) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    btn.disabled = true;
    var old = btn.textContent;
    btn.textContent = 'Adding…';

    var pageItems = document.getElementById('main-cart-items');
    var pageFooter = document.getElementById('main-cart-footer');
    var pageSections = [];
    if (pageItems && pageFooter) {
      pageSections = [pageItems, pageFooter];
    }
    var sections = ['cart-drawer', 'cart-icon-bubble'].concat(
      pageSections.map(function (section) { return section.dataset.id; })
    );

    try {
      var res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(id), quantity: 1, properties: { _rp_stack_offer: '1' } }],
          sections: sections,
          sections_url: window.location.pathname,
        }),
      });
      if (!res.ok) throw new Error('add failed');
      var data = await res.json();
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
        pageSections.forEach(function (section) {
          var html = data.sections[section.dataset.id];
          var contents = section.querySelector('.js-contents');
          var replacement = html && new DOMParser().parseFromString(html, 'text/html').querySelector('.js-contents');
          if (!contents || !replacement) throw new Error('cart section missing');
          contents.innerHTML = replacement.innerHTML;
        });
        drawer.renderContents({ id: Number(id), sections: data.sections });
      } else {
        window.location.href = root + 'cart';
      }
    } catch (e) {
      console.error(e);
      if (typeof data !== 'undefined' && data.sections) {
        // The item was added; reload the authoritative cart instead of inviting a duplicate add.
        window.location.href = root + 'cart';
      } else {
        btn.disabled = false;
        btn.textContent = old || 'Add for $15';
        alert('Could not add stack offer — please try again.');
      }
    }
  });
})();
